<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Define the ordered tokens (prefix, number, date…) that build each series number.</p>
        </div>
        <p-button label="Add Token" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>

    <div class="card">
        <div class="toolbar">
            <div class="filter">
                <label>Series</label>
                <p-select [ngModel]="selectedSeries()" (ngModelChange)="selectedSeries.set($event != null ? +$event : null)" [options]="masters()" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="All series" appendTo="body" />
            </div>
            @if (preview()) {
                <span class="preview">Preview: <strong>{{ preview() }}</strong></span>
            }
        </div>

        <p-table [value]="visibleFormats()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="visibleFormats().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm"
            [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 90px">Order</th>
                    <th>Series</th>
                    <th>Token Type</th>
                    <th>Value</th>
                    <th>Padding</th>
                    <th class="ta-r" style="width: 110px">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-f>
                <tr>
                    <td><span class="order">{{ f.tokenOrder }}</span></td>
                    <td class="strong">{{ seriesName(f.seriesId) }}</td>
                    <td><span class="chip">{{ f.tokenType }}</span></td>
                    <td class="mono">{{ f.tokenValue || '—' }}</td>
                    <td class="muted">{{ f.padding ?? '—' }}</td>
                    <td class="ta-r">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Edit" (onClick)="openEdit(f)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(f)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">
                        <div class="state"><i class="pi pi-inbox"></i><p>No format tokens yet. Click <strong>Add Token</strong> to create one.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [header]="editing() ? 'Edit Token' : 'Add Format Token'" styleClass="menu-dialog"
    [style]="{ width: '480px' }" [breakpoints]="{ '480px': '94vw' }">
    <form [formGroup]="form" class="menu-form">
        <div class="field">
            <label>Series <span class="req">*</span></label>
            <p-select formControlName="seriesId" [options]="masters()" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" placeholder="Select a series..." appendTo="body" />
            @if (!masters().length) {
                <small class="hint">No series found — create one in <b>Series Master</b> first.</small>
            }
            @if (form.get('seriesId')?.touched && form.get('seriesId')?.invalid) {
                <small class="err">Required</small>
            }
        </div>

        <div class="grid-2">
            <div class="field">
                <label>Token Type <span class="req">*</span></label>
                <p-select formControlName="tokenType" [options]="tokenTypes" placeholder="Select token type" appendTo="body" />
            </div>
            <div class="field">
                <label>Order <span class="req">*</span></label>
                <input pInputText type="number" formControlName="tokenOrder" min="1">
            </div>
        </div>

        <div class="grid-2">
            <div class="field">
                <label>Value <small class="muted">(for Prefix / Text / Separator)</small></label>
                <input type="text" pInputText formControlName="tokenValue" placeholder="INV">
            </div>
            <div class="field">
                <label>Padding <small class="muted">(for Number)</small></label>
                <input pInputText type="number" formControlName="padding" min="0" placeholder="4">
            </div>
        </div>

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button [label]="saving() ? 'Saving...' : 'Save'"
                [icon]="saving() ? 'pi pi-spin pi-spinner' : ''" (onClick)="save()" [loading]="saving()" />
        </div>
    </form>
</p-dialog>
